/* eslint max-len: 0 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, FormattedHTMLMessage, injectIntl } from 'react-intl'
import { reduxForm } from 'redux-form'
import { FieldError, ErrorField, BirthdateField, CharField,
  RadioField, CheckboxField, CountrySelector } from 'components/forms'
import { Button } from 'components/util'
import * as authActions from 'services/auth/actions'
import * as consentActions from 'services/consents/actions'
import * as auth from 'services/auth/selectors'
import * as bootupSelectors from 'services/bootup/selectors'
import * as siteSelectors from 'services/site/selectors'
import * as consents from 'services/consents/selectors'
import * as routingSelectors from 'services/routing/selectors'
import styles from './_signup.css'
import validate from './validate'
import ErrorComponent from '../ErrorComponent'
import messages from '../messages'
import { changeBulk } from 'shared/actions'
import ReCAPTCHA from 'react-google-recaptcha'
import { selectConsentDetailsForIsoCode } from 'shared/consentsUtil'
import wechatConstants from '../../../../shared/constants/wechat'

export const FORM_NAME = 'signup'
let captcha

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => ({
  accountPortalRoot: bootupSelectors.selectAccountPortalRoot(state),
  appConfig: bootupSelectors.selectAppConfig(state),
  country: auth.selectAuthCountry(state),
  customerSupportEmail: bootupSelectors.selectCustomerSupportEmail(state),
  site: siteSelectors.selectSite(state),
  onboarding: auth.selectOnboarding(state),
  initialFormValues: auth.selectOnboardingInitialFormValues(state),
  isDev: siteSelectors.selectDev(state),
  consentMatrix: consents.selectConsentMatrix(state),
  reCaptchaResponse: auth.selectRecaptchaResponse(state),
  location: routingSelectors.selectLocation(state),
  isWechatAuth: auth.selectIsWechatAuth(state),
})

const mapDispatchToActions = {
  ...authActions,
  ...consentActions,
  changeBulk,
}

// TODO does this change for isChina?
const CODE_US = 'US' // Country or Standard

export class SignupForm extends Component {

  static propTypes = {
    accountPortalRoot: PropTypes.string,
    appConfig: PropTypes.object,
    intl: PropTypes.object,
    invalid: PropTypes.bool,
    country: PropTypes.string,
    customerSupportEmail: PropTypes.string,
    site: PropTypes.object,
    onboarding: PropTypes.string,
    signingUp: PropTypes.bool,
    initialFormValues: PropTypes.object,
    onClickSignup: PropTypes.func,
    onClickForgotPassword: PropTypes.func,
    onLoginSuccess: PropTypes.func,
    handleSubmit: PropTypes.func,
    fetchGeoIp: PropTypes.func,
    changeBulk: PropTypes.func,
    error: PropTypes.string,
    isDev: PropTypes.bool,
    consentMatrix: PropTypes.object,
    fetchConsentMatrix: PropTypes.func,
    gdpr_iso_code: PropTypes.string,
    showSpinner: PropTypes.func,
    reCaptchaResponse: PropTypes.string,
    isWechatAuth: PropTypes.bool,
    location: PropTypes.object,
  }

  state = {
    privacyStandard: CODE_US,
  }

  componentWillMount () {
    this.props.fetchGeoIp()
      .then(() => {
        const { country, onboarding, initialFormValues } = this.props
        let initialData = { promotionalPreference: this.isUS(country),
          gdpr_iso_code: (country || CODE_US).toUpperCase() }
        this.handleCountryChange(undefined, country)
        // merge in onboarding data if onboarding
        if (onboarding) {
          initialData = { ...initialData, ...initialFormValues }
        }

        this.props.changeBulk(FORM_NAME, initialData)
      })

    if (this.props.isWechatAuth) {
      this.doWechatAutofill()
    }
  }

  componentWillReceiveProps (nextProps) {
    if ('onboarding' in nextProps && nextProps.onboarding !== this.props.onboarding) {
      this.props.changeBulk(FORM_NAME, nextProps.initialFormValues)
    }
  }

  componentDidUpdate () {
    const { error } = this.props
    const { disableCaptcha } = this.props.appConfig
    if (error && !disableCaptcha) {
      captcha.reset()
    }
  }

  handleCountryChange = (event, country) => {
    this.props.showSpinner(true)
    this.props.fetchConsentMatrix(country)
      .then(() => {
        const consentDetails = selectConsentDetailsForIsoCode(this.props.consentMatrix, country)
        const { standard } = consentDetails
        this.setState({
          privacyStandard: standard,
        })
        if (this.isUS(standard)) {
          this.props.changeBulk(FORM_NAME, { terms: true })
        }
        this.props.showSpinner(false)
      })
  }

  isUS (code) {
    return (code && code.toUpperCase()) === CODE_US
  }

  handleAutofillNewUser = () => {
    this.props.changeBulk(FORM_NAME, {
      firstName: 'Autogenerated',
      lastName: 'Autogenerated',
      email: `autotestmmf_${Date.now()}@gmail.com`,
      password: 'password',
      day: '26',
      month: '12',
      year: '1981',
      gdpr_iso_code: 'US',
      gender: 'M',
      terms: true,
      promotionalPreference: false,
    })
  }

  doWechatAutofill = () => {
    const { location } = this.props
    this.props.changeBulk(FORM_NAME, {
      firstName: location.query[wechatConstants.WECHAT_NICKNAME_PARAM],
      gender: location.query[wechatConstants.WECHAT_GENDER_PARAM],
    })
  }

  render () {
    const {
      accountPortalRoot,
      appConfig,
      customerSupportEmail,
      handleSubmit,
      intl,
      site,
      gdpr_iso_code,
      signingUp,
      onboarding,
      error,
      isDev,
      invalid,
      reCaptchaResponse,
      isWechatAuth,
    } = this.props
    const privacyStandard = this.state.privacyStandard

    const firstNameComponent = (
      <CharField
        slim
        maxLength={30}
        name='firstName'
        placeholder={intl.formatMessage(messages.firstName)}
        labelComponent={null}
        normalize={(value) => value.trim()}
        disabled={signingUp}
        errorComponent={(
          <ErrorComponent name={intl.formatMessage(messages.firstName)} />
        )}
      />
    )

    const lastNameComponent = (
      <CharField
        slim
        maxLength={30}
        name='lastName'
        placeholder={intl.formatMessage(messages.lastName)}
        labelComponent={null}
        normalize={(value) => value.trim()}
        disabled={signingUp}
        errorComponent={(
          <ErrorComponent name={intl.formatMessage(messages.lastName)} />
        )}
      />
    )

    const orderedNameComponents = appConfig.isChina ?
      [lastNameComponent, firstNameComponent] :
      [firstNameComponent, lastNameComponent]

    return (
      <form>

        {appConfig.disableCaptcha ? null :
          <ReCAPTCHA
            ref={(el) => { captcha = el }}
            size="invisible"
            sitekey="6LcxilMUAAAAAO58qmA-RhNUA2OWX_UbTPWCireM" // TODO WWW-2109
            onChange={
              (value) => {
                this.props.changeBulk(FORM_NAME, {
                  'g-recaptcha-response': value,
                })
                handleSubmit()
              }
            }
          />
        }

        {isDev ?
          <Button
            type='danger'
            onClick={this.handleAutofillNewUser}
            className={styles.autofillButton}
          >
            <FormattedMessage
              id='auth.signup.autofill'
              defaultMessage='Autofill New User'
            />
          </Button>
        : null}

        {orderedNameComponents}

        <CharField
          slim
          name='email'
          placeholder={intl.formatMessage(messages.email)}
          normalize={(value) => value.trim()}
          labelComponent={null}
          disabled={signingUp}
          errorComponent={(
            <ErrorComponent name={intl.formatMessage(messages.email)} />
          )}
        />

        <CharField
          name='profileUrl'
          className={styles.honeypot}
        />

        {!onboarding && !isWechatAuth ?
          <CharField
            slim
            name='password'
            type='password'
            placeholder={intl.formatMessage(messages.password)}
            labelComponent={null}
            normalize={(value) => value.trim()}
            disabled={signingUp}
            errorComponent={(
              <ErrorComponent name={intl.formatMessage(messages.password)} />
            )}
          />
        : null}

        <BirthdateField
          slim
          formName={FORM_NAME}
          isChina={appConfig.isChina}
          name='birthdate'
          errorComponent={(
            <ErrorComponent name={intl.formatMessage(messages.birthdate)} />
          )}
        />

        <div className={styles.gender}>
          <div className={styles.male}>
            <RadioField
              slim
              button
              value='M'
              name='gender'
              icon='radio_check'
              disabled={signingUp}
              className={styles.maleLabel}
              labelComponent={(
                <FormattedMessage
                  id='auth.signup.male'
                  defaultMessage='Male'
                />
              )}
              errorComponent={null}
            />
          </div>
          <div className={styles.female}>
            <RadioField
              slim
              button
              value='F'
              name='gender'
              icon='radio_check'
              disabled={signingUp}
              className={styles.femaleLabel}
              labelComponent={(
                <FormattedMessage
                  id='auth.signup.female'
                  defaultMessage='Female'
                />
              )}
              errorComponent={null}
            />
          </div>
        </div>
        <ErrorField
          slim
          name='gender'
          labelComponent={null}
          errorComponent={(
            <ErrorComponent name={intl.formatMessage(messages.gender)} />
          )}
        />

        <CountrySelector
          slim
          name='gdpr_iso_code'
          className={styles.gdprIsoCode}
          placeholder={intl.formatMessage(messages.country)}
          onChange={this.handleCountryChange}
          required={true}
          labelComponent={null}
          errorComponent={(
            <ErrorComponent name={intl.formatMessage(messages.country)} />
          )}
        />

        <CheckboxField
          slim
          name='promotionalPreference'
          disabled={signingUp}
          className={styles.note}
          labelComponent={(
            <div>
              {gdpr_iso_code !== 'ca' ?  // eslint-disable-line camelcase
                <FormattedMessage
                  id='auth.signup.promotional_preference'
                  defaultMessage='Yes, I would like to receive by email the latest news, innovation updates, and offers from {siteName} and Under Armour.'
                  values={{ siteName: site.name }}
                />
              :
                <FormattedHTMLMessage
                  id='auth.signup.promotional_preference_ca'
                  defaultMessage={`
                    Yes, I agree to receive by email the latest news, innovation, updates, and offers from {siteName}
                    and Under Armour, Inc. You may unsubscribe at any time. See our  <a href="{privacyLink}" target="_blank" rel="noopener noreferrer" class="link">Privacy Policy</a> or <a href="mailto:{email}">Contact us</a> for more information 1020 Hull Street, Baltimore MD 21230
                  `}
                  values={{
                    privacyLink: `${accountPortalRoot}/privacy/`,
                    siteName: site.name,
                    email: customerSupportEmail,
                  }}
                />
              }
            </div>
          )}
          errorComponent={null}
        />

        {this.isUS(privacyStandard) ?
          <p className={styles.termsAndPrivacyNote}>
            <FormattedHTMLMessage
              id='auth.signup.terms_and_privacy_note'
              defaultMessage={`
                By signing up with {siteName}, you agree to our
                <a href="{privacyLink}" target="_blank" rel="noopener noreferrer" class="link">Privacy Policy</a>
                & <a href="{termsLink}" target="_blank" rel="noopener noreferrer" class="link">Terms of Use.</a> 
              `}
              values={{
                siteName: site.name,
                privacyLink: `${accountPortalRoot}/privacy/`,
                termsLink: `${accountPortalRoot}/terms-and-conditions/`,
              }}
            />
          </p>
        : <CheckboxField
          slim
          name='terms'
          className={styles.note}
          disabled={signingUp}
          labelComponent={(
            <FormattedHTMLMessage
              id='auth.signup.terms_checkbox'
              defaultMessage={`
                I have read and agree to the <a href="{privacyLink}" target="_blank" rel="noopener noreferrer" class="link">Privacy Policy</a> & <a href="{termsLink}" target="_blank" rel="noopener noreferrer" class="link">Terms of Use</a>.
              `}
              values={{
                privacyLink: `${accountPortalRoot}/privacy/`,
                termsLink: `${accountPortalRoot}/terms-and-conditions/`,
              }}
            />
          )}
          errorComponent={(
            <ErrorComponent name={intl.formatMessage(messages.terms)} />
          )}
        />}

        {/* server or form-wide errors, like birthdate too young */}
        {error ?
          <FieldError
            showError={!!error}
            errorMessage={error}
            className={styles.fieldError}
            errorComponent={(<ErrorComponent />)}
          />
        : null}

        <Button
          el='button'
          type='success'
          className={styles.button}
          onClick={(event) => {
            event.preventDefault()
            if (appConfig.disableCaptcha || invalid || reCaptchaResponse) {
              handleSubmit()
            } else {
              captcha.execute()
            }

          }}
        >
          <FormattedMessage
            id='auth.signup.sign_up'
            defaultMessage='Sign up'
          />
        </Button>

      </form>
    )
  }

}

export const Form = reduxForm(formOptions)(SignupForm)
export const IntlForm = injectIntl(Form)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(IntlForm)
